import * as actionTypes from '@store/actions/actionTypes'
import { defaultBoundingBox, searchResultsLimits } from '@util/constants'

const initialState = {
  filterCriteria: {
    heroSize: 'medium',
    limitResults: searchResultsLimits.cards,
    filter: {
      counties: [],
      cities: [],
      zipCodes: [],
      listPrice: {
        min: null,
        max: null
      },
      forSaleRent: undefined,
      dateAvailable: {},
      furnishedRentals: [],
      nonAssistivePets: []
    },
    viewBounds: defaultBoundingBox,
    sortBy: {
      id: 'logicalStatus',
      order: 'asc'
    },
    geometry: {}
  },
  defaultFilters: {
    listPrice: {
      min: null,
      max: null
    },
    forSaleRent: undefined
  },
  visibleOnResultsPage: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VIEW_BOUNDS:
      return {
        ...state,
        filterCriteria: {
          ...state.filterCriteria,
          viewBounds: action.bounds
        }
      }
    case actionTypes.SET_FILTER_GEOMETRY:
      return {
        ...state,
        filterCriteria: {
          ...state.filterCriteria,
          geometry: action.geometry
        }
      }
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        searchName: null,
        filterCriteria: {
          ...state.filterCriteria,
          filter: {
            ...state.filterCriteria.filter,
            [action.filter.id]: action.filter.filterData
          },
          viewBounds: action.viewBounds
            ? action.viewBounds
            : state.filterCriteria.viewBounds
        }
      }
    case actionTypes.CLEAR_FILTER_REGIONS: {
      const {
        filter: { cities, zipCodes, counties, ...f }
      } = state.filterCriteria
      return {
        ...state,
        searchName: null,
        filterCriteria: {
          ...state.filterCriteria,
          filter: {
            ...state.filterCriteria.filter,
            ...f
          }
        }
      }
    }
    case actionTypes.SET_SORT_BY:
      return {
        ...state,
        filterCriteria: {
          ...state.filterCriteria,
          sortBy: action.sortBy
        }
      }
    case actionTypes.SET_DEFAULT_FILTER:
      return {
        ...state,
        defaultFilters: {
          ...state.defaultFilters,
          [action.filter.id]: action.filter.filterData
        }
      }
    case actionTypes.RESET_FILTERS:
      return {
        ...state,
        searchName: null,
        filterCriteria: {
          ...state.filterCriteria,
          filter: state.defaultFilters,
          docIds: [],
          geometry: { type: 'FeatureCollection', features: [] },
          viewBounds: action.viewBounds ?? state.filterCriteria.viewBounds
        }
      }
    case actionTypes.SET_FILTERS_VISIBLE_ON_RESULTS_PAGE:
      return {
        ...state,
        visibleOnResultsPage: action.visible
      }
    case actionTypes.SET_FILTER_CRITERIA:
      return {
        ...state,
        filterCriteria: {
          ...state.filterCriteria,
          filter: {
            ...state.defaultFilters,
            ...action.filterCriteria
          }
        }
      }
    case actionTypes.SET_AI_SEARCH:
      return {
        ...state,
        filterCriteria: {
          ...initialState.filterCriteria,
          filter: {
            ...initialState.filterCriteria.filter,
            ...action.filter
          },
          viewBounds: action.viewBounds || defaultBoundingBox
        }
      }
    case actionTypes.SET_SEARCH_NAME:
      return {
        ...state,
        searchName: action.name
      }
    case actionTypes.REMOVE_COMMUTE_FILTER:
      /* eslint-disable no-case-declarations */
      const { commute, ...rest } = state.filterCriteria.filter
      return {
        ...state,
        filterCriteria: {
          ...state.filterCriteria,
          filter: rest
        }
      }
    case actionTypes.ADD_COMMUTE_FILTER:
      return {
        ...state,
        filterCriteria: {
          ...state.filterCriteria,
          filter: {
            ...state.filterCriteria.filter,
            commute: action.commute
          }
        }
      }
    case actionTypes.SET_FILTER_PROPERTIES_ERROR:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default reducer
